"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6542],{

/***/ 79550:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 92064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ footerMenu; }
/* harmony export */ });
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71571);

var footerMenu = {
    copy: "\xa9 ".concat(new Date().getFullYear(), " DemystData, Ltd."),
    social: [
        {
            type: "LinkedIn",
            url: "https://www.linkedin.com/company/demystdata"
        }
    ],
    columns: [
        {
            header: "Company",
            items: [
                {
                    name: "Contact us",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.CONTACT */ .s.CONTACT,
                    isExternal: false
                }
            ]
        },
        {
            header: "Legal",
            items: [
                {
                    name: "Privacy Policy",
                    shortName: "Privacy",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.PRIVACY */ .s.PRIVACY,
                    isExternal: false
                },
                {
                    name: "Accessibility Policy",
                    shortName: "Accessibility",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.ACCESSIBILITY */ .s.ACCESSIBILITY,
                    isExternal: false
                },
                {
                    name: "Terms and Conditions",
                    shortName: "Terms",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.TERMS */ .s.TERMS,
                    isExternal: false
                },
                {
                    name: "Cookie Policy",
                    shortName: "Cookies",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.COOKIE_POLICY */ .s.COOKIE_POLICY,
                    isExternal: false
                },
                {
                    name: "Manage Cookies",
                    hideShort: true,
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.MANAGE_COOKIE */ .s.MANAGE_COOKIE,
                    isExternal: false
                },
                {
                    name: "Personal Information Request (CA)",
                    hideShort: true,
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.CCPA */ .s.CCPA,
                    isExternal: false
                },
                {
                    name: "Data Subject Action Request",
                    hideShort: true,
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.DSAR */ .s.DSAR,
                    isExternal: false
                }, 
            ]
        }, 
    ]
};


/***/ }),

/***/ 36542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/landingPage/assets/svg/DemystLogo.svg
var DemystLogo = __webpack_require__(79550);
// EXTERNAL MODULE: ./src/landingPage/datasets/footerMenu.js
var footerMenu = __webpack_require__(92064);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/landingPage/views/components/logic/PauseOutsideViewport.jsx



var PauseOutsideViewport = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var toggleAnimation = function(state) {
        var animationsToPause = props.animationsToPause;
        var list = [];
        if (animationsToPause.ids.length !== 0) {
            list = (0,_to_consumable_array/* default */.Z)(list).concat((0,_to_consumable_array/* default */.Z)(document.querySelectorAll(animationsToPause.ids)));
        }
        if (animationsToPause.childrenOf.length !== 0) {
            animationsToPause.childrenOf.forEach(function(parent) {
                if (document.querySelector(parent) !== null) list = (0,_to_consumable_array/* default */.Z)(list).concat((0,_to_consumable_array/* default */.Z)(document.querySelector(parent).childNodes));
            });
        }
        list.forEach(function(item) {
            if (state === "pause") {
                item.classList.add("pause");
            } else if (state === "run") {
                item.classList.remove("pause");
            }
        });
    };
    (0,react.useEffect)(function() {
        if ("IntersectionObserver" in window) {
            var observer = new IntersectionObserver(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
                if (entry.isIntersecting === false) {
                    toggleAnimation("pause");
                } else {
                    toggleAnimation("run");
                }
            }, {
                root: null,
                rootMargin: "0px",
                threshold: 0.1
            });
            if (ref.current) {
                observer.observe(ref.current);
            }
        }
    }, [
        ref
    ]);
    return null;
});

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/components/LinkButton.jsx
var LinkButton = __webpack_require__(84135);
;// CONCATENATED MODULE: ./src/landingPage/layouts/LayoutComponents/Footer.jsx












function Footer(param) {
    var _showNav = param.showNav, showNav = _showNav === void 0 ? true : _showNav;
    var ref;
    var router = (0,next_router.useRouter)();
    var current = router.asPath;
    var ref1 = /*#__PURE__*/ (0,react.createRef)();
    var isLanding = !showNav;
    var animationsToPause = {
        childrenOf: [
            "#footer_data_lanes"
        ],
        ids: []
    };
    var scroll = function(link) {
        if (current === "/platform" || link.indexOf("#") !== -1) {
            var hash = link.slice(link.indexOf("#") + 1);
            var element = document.getElementById(hash);
            if (element !== null) {
                var rect = element.getBoundingClientRect();
                var scrollTop = window.pageYOffset;
                var result = rect.top + scrollTop - 130;
                window.scrollTo({
                    top: result,
                    left: 0,
                    behavior: "smooth"
                });
            }
        }
    };
    var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (0,clsx_m/* default */.Z)("layout-footer", isLanding && "layout-footer-landing"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PauseOutsideViewport, {
                        ref: ref1,
                        animationsToPause: animationsToPause
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "layout-footer-main",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "layout-footer-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        className: "layout-header-logo",
                                        title: "Return home",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: DemystLogo/* default.src */.Z.src,
                                            className: "layout-footer-logo",
                                            alt: "Demyst",
                                            width: "162",
                                            height: "40",
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "layout-footer-social",
                                        children: (ref = footerMenu/* footerMenu.social */.T.social) === null || ref === void 0 ? void 0 : ref.map(function(link) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "layout-footer-social-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: link.url,
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    className: "layout-footer-social-link",
                                                    title: link.type,
                                                    children: [
                                                        link.type == "Twitter" && /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiTwitter */.Ccr, {
                                                            alt: "Twitter icon"
                                                        }),
                                                        link.type == "LinkedIn" && /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiLinkedin */.qOw, {
                                                            alt: "Linkedin icon"
                                                        })
                                                    ]
                                                })
                                            }, link.type);
                                        })
                                    }),
                                    isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        className: "layout-footer-landingNav",
                                        children: footerMenu/* footerMenu.columns.filter */.T.columns.filter(function(c) {
                                            return c.header === "Legal";
                                        }).map(function(c) {
                                            return c.items.map(function(link, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            href: link.url
                                                        }, link.isExternal && {
                                                            target: "_blank",
                                                            rel: "noreferrer"
                                                        }), {
                                                            className: "layout-footer-landingNav-link",
                                                            onClick: function() {
                                                                return scroll(link.url);
                                                            },
                                                            children: link.name
                                                        })),
                                                        index < c.items.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "layout-footer-landingNav-divider",
                                                            children: "\xb7"
                                                        })
                                                    ]
                                                });
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "layout-footer-copy",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: footerMenu/* footerMenu.copy */.T.copy
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "All rights reserved."
                                            })
                                        ]
                                    }),
                                    isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                                        className: "layout-footer-toTop",
                                        onClick: function() {
                                            return scrollToTop();
                                        },
                                        children: "Back To Top"
                                    })
                                ]
                            }),
                            !isLanding && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: "layout-footer-nav",
                                children: footerMenu/* footerMenu.columns.map */.T.columns.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "layout-footer-column-".concat(index),
                                        "aria-label": "layout-footer-column-".concat(index),
                                        className: "layout-footer-column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "layout-footer-header",
                                                children: item.header
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: item.items.map(function(link) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "layout-footer-list-item",
                                                        children: [
                                                            link.img ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: link.img.src,
                                                                alt: ""
                                                            }) : null,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                href: link.url
                                                            }, link.isExternal && {
                                                                target: "_blank",
                                                                rel: "noreferrer"
                                                            }), {
                                                                className: "layout-footer-link",
                                                                onClick: function() {
                                                                    return scroll(link.url);
                                                                },
                                                                children: link.name
                                                            }))
                                                        ]
                                                    }, link.name);
                                                })
                                            })
                                        ]
                                    }, item.header);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://ws.zoominfo.com/pixel/62b92deed06391008ee7e092",
                    width: "1",
                    height: "1",
                    style: {
                        display: "none"
                    },
                    alt: "websights"
                })
            })
        ]
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ })

}]);